import { Header, HeroImage, HeroSection, SubHeader, HeroOverlay, Button, ButtonsWrapper } from "./styled";
import Hero480 from "./baner-480.webp";
import Hero768 from "./baner-768.webp";
import Hero1080 from "./baner-1080p.webp";
import Hero1440 from "./baner-1440p.webp";
import { useTranslation } from "react-i18next";

const Hero = () => {
    const { t } = useTranslation();

    const offset = window.innerWidth <= 768 ? -50 : -90;

    return (
        <HeroSection id="home">
            <picture>
                <source
                    type="image/webp"
                    srcSet={`${Hero480} 480w, ${Hero768} 768w, ${Hero1080} 1080w, ${Hero1440} 1440w`}
                    sizes="100vw"
                />
                <HeroImage
                    src={Hero1080}
                    srcSet={`${Hero480} 480w, ${Hero768} 768w, ${Hero1080} 1080w, ${Hero1440} 1440w`}
                    sizes="100vw"
                    alt={t("hero.alt")}
                    loading="eager"
                    fetchpriority="high"
                    decoding="async"
                    width="1920"
                    height="1080"
                />
            </picture>

            <HeroOverlay>
                <Header>{t("hero.title")}</Header>
                <SubHeader>{t("hero.subtitle")}</SubHeader>

                <ButtonsWrapper>
                    <Button to="services" href="#services" smooth duration={600} offset={offset}>
                        {t("hero.cta.offer")}
                    </Button>

                    <Button to="address" href="#address" smooth duration={600} offset={offset}>
                        {t("hero.cta.contact")}
                    </Button>
                </ButtonsWrapper>
            </HeroOverlay>
        </HeroSection>
    );
};

export default Hero;